export default function (imageUrl, text, target = 'other') {
  return this.sendEventWithCallback('digitalFlyers.share', { image_url: imageUrl, text, target })
    .then(data => {
      // shortcut: success
      if (data.shared === true) {
        return
      }

      return Promise.reject(
        new Error(this.ERROR_UNKNOWN)
      )
    })
}
